import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import type { IDrawingTicket } from 'types/IDrawingTicket';
import { formatCurrencyEuro, formatCount } from './formatCurrency';
import { formatDate } from './formatDate';

/**
 * Build the ticket list of one drawing as a PDF and hand it to the browser,
 * the way the legacy "Die für diese Ziehung gespeicherten Lose als PDF
 * herunterladen" action did.
 */
export const downloadTicketPdf = (tickets: IDrawingTicket[], drawingTypeName: string, drawingDate: string): void => {
  const title = `${drawingTypeName} vom ${formatDate(drawingDate)}`;
  const total = tickets.reduce((sum, ticket) => sum + Number(ticket.amount), 0);

  const byAmount = new Map<number, number>();
  tickets.forEach((ticket) => {
    const amount = Number(ticket.amount);
    byAmount.set(amount, (byAmount.get(amount) ?? 0) + 1);
  });
  const grouped = [...byAmount.entries()]
    .sort(([a], [b]) => a - b)
    .map(([amount, count]) => `${formatCount(count)} x ${formatCurrencyEuro(amount)}: ${formatCurrencyEuro(amount * count)}`);

  const doc = new jsPDF();
  const marginLeft = 14;
  const lineHeight = 10;
  let y = lineHeight;

  const paragraph = (text: string) => {
    doc.text(text, marginLeft, y);
    y += lineHeight;
  };

  paragraph(title);
  paragraph(`Losanzahl: ${formatCount(tickets.length)}`);
  paragraph(`Gesamtgewinn: ${formatCurrencyEuro(total)}`);
  paragraph('Nach Gewinnsumme gruppiert:');
  grouped.forEach(paragraph);

  autoTable(doc, {
    startY: y,
    head: [['Losnummer', 'Gewinn']],
    body: [...tickets]
      .sort((a, b) => Number(a.number) - Number(b.number))
      .map((ticket) => [String(ticket.number), formatCurrencyEuro(ticket.amount)]),
  });

  doc.save(`download_${formatDate(new Date())}.pdf`);
};
